document.addEventListener( 'DOMContentLoaded', () => {
	class TABTOGGLECONTENT {
		static CLASS_NAME_ITEMS = 'jtf__tabtoggleblock__items'
		static CLASS_NAME_ITEM = 'jtf__tabtoggleblock__items__item'
		static CLASS_NAME_ITEM_SELECTED = 'jtf__tabtoggleblock__items__item--selected'
		static CLASS_NAME_CONTENT = 'jtf__tabtoggleblock__content'
		static CLASS_NAME_TABS_LEFT = 'jtf__tabtoggleblock--tabsleft'
		static CLASS_NAME_COL_CONTAINER = 'jtf__tabtoggleblock--colcontainer'
		static SELECTOR_CLASS_BLOCK = '.wp-block-jtf-jtf-tab-toggle-content'
		static SELECTOR_CLASS_COL_12 = '.col-12'
		static ATTR_DATA_BLOCKNAME = 'data-blockname'
		static ATTR_DATA_ITEMNAME = 'data-itemname'
		static ATTR_ARIA_SELECTED = 'aria-selected'
		static ATTR_TABINDEX = 'tabindex'
		static KEYCODE_ARROW_RIGHT = 'ArrowRight'
		static KEYCODE_ARROW_DOWN = 'ArrowDown'
		static KEYCODE_ARROW_LEFT = 'ArrowLeft'
		static KEYCODE_ARROW_UP = 'ArrowUp'
		static KEYCODE_HOME = 'Home'
		static KEYCODE_END = 'End'

		constructor( instance ) {
			this.instance = instance
			this.init()
		}

		init() {
			const itemsEl = this.instance.querySelector( '.' + TABTOGGLECONTENT.CLASS_NAME_ITEMS )
			const blockName = itemsEl ? itemsEl.getAttribute( TABTOGGLECONTENT.ATTR_DATA_BLOCKNAME ) : ''
			const selectedItem = this.instance.querySelector( '.' + TABTOGGLECONTENT.CLASS_NAME_ITEM_SELECTED )
			let itemName = selectedItem ? selectedItem.getAttribute( TABTOGGLECONTENT.ATTR_DATA_ITEMNAME ) : ''

			if ( blockName && itemName ) {
				this.hideAllContent( blockName, itemName )
			}

			this.instance.addEventListener( 'click', ( e ) => {
				const item = e.target.closest( '.' + TABTOGGLECONTENT.CLASS_NAME_ITEM )
				if ( item ) {
					itemName = item.getAttribute( TABTOGGLECONTENT.ATTR_DATA_ITEMNAME )
					this.activateTab( item, blockName, itemName )
				}
			} )

			this.instance.addEventListener( 'keydown', ( e ) => {
				const currentTab = e.target.closest( '.' + TABTOGGLECONTENT.CLASS_NAME_ITEM )
				if ( currentTab ) {
					const allTabs = Array.from( this.instance.querySelectorAll( '.' + TABTOGGLECONTENT.CLASS_NAME_ITEM ) )
					const currentIndex = allTabs.indexOf( currentTab )
					let targetTab = null

					switch ( e.key ) {
						case TABTOGGLECONTENT.KEYCODE_ARROW_RIGHT:
						case TABTOGGLECONTENT.KEYCODE_ARROW_DOWN: {
							e.preventDefault()
							targetTab = currentIndex < allTabs.length - 1 ? allTabs[ currentIndex + 1 ] : allTabs[ 0 ]
							break
						}
						case TABTOGGLECONTENT.KEYCODE_ARROW_LEFT:
						case TABTOGGLECONTENT.KEYCODE_ARROW_UP: {
							e.preventDefault()
							targetTab = currentIndex > 0 ? allTabs[ currentIndex - 1 ] : allTabs[ allTabs.length - 1 ]
							break
						}
						case TABTOGGLECONTENT.KEYCODE_HOME: {
							e.preventDefault()
							targetTab = allTabs[ 0 ]
							break
						}
						case TABTOGGLECONTENT.KEYCODE_END: {
							e.preventDefault()
							targetTab = allTabs[ allTabs.length - 1 ]
							break
						}
						default: {
							break
						}
					}

					if ( targetTab ) {
						const targetItemName = targetTab.getAttribute( TABTOGGLECONTENT.ATTR_DATA_ITEMNAME )
						this.activateTab( targetTab, blockName, targetItemName )
						targetTab.focus()
					}
				}
			} )

			const targetElement = this.instance.querySelector( '.' + TABTOGGLECONTENT.CLASS_NAME_TABS_LEFT )
			if ( targetElement ) {
				const colParent = targetElement.closest( TABTOGGLECONTENT.SELECTOR_CLASS_COL_12 )
				if ( colParent ) {
					colParent.classList.add( TABTOGGLECONTENT.CLASS_NAME_COL_CONTAINER )
				}
			}
		}

		activateTab( targetTab, blockName, itemName ) {
			const items = this.instance.querySelectorAll( '.' + TABTOGGLECONTENT.CLASS_NAME_ITEM )
			items.forEach( ( item ) => {
				item.classList.remove( TABTOGGLECONTENT.CLASS_NAME_ITEM_SELECTED )
				item.setAttribute( TABTOGGLECONTENT.ATTR_ARIA_SELECTED, 'false' )
				item.setAttribute( TABTOGGLECONTENT.ATTR_TABINDEX, '-1' )
			} )

			targetTab.classList.add( TABTOGGLECONTENT.CLASS_NAME_ITEM_SELECTED )
			targetTab.setAttribute( TABTOGGLECONTENT.ATTR_ARIA_SELECTED, 'true' )
			targetTab.setAttribute( TABTOGGLECONTENT.ATTR_TABINDEX, '0' )

			if ( blockName && itemName ) {
				this.hideAllContent( blockName, itemName )
			}
		}

		// noinspection FunctionWithMultipleLoopsJS
		hideAllContent( blockName, itemName ) {
			const blockNameClass = '.' + TABTOGGLECONTENT.CLASS_NAME_CONTENT + '__blockname--' + blockName
			const blockElements = document.querySelectorAll( blockNameClass )

			if ( blockElements.length > 0 ) {
				const itemNameClass = '.' + TABTOGGLECONTENT.CLASS_NAME_CONTENT + '__itemname--' + itemName
				blockElements.forEach( ( el ) => {
					el.style.display = 'none'
				} )

				const targetElements = document.querySelectorAll( blockNameClass + itemNameClass )
				targetElements.forEach( ( el ) => {
					el.style.display = 'block'
					el.style.opacity = '0'
					setTimeout( () => {
						el.style.transition = 'opacity 0.4s'
						el.style.opacity = '1'
					}, 10 )
				} )
			}
		}
	}

	const blocks = document.querySelectorAll( TABTOGGLECONTENT.SELECTOR_CLASS_BLOCK )
	if ( blocks.length > 0 ) {
		blocks.forEach( ( block ) => {
			new TABTOGGLECONTENT( block )
		} )
	}
} )
